import Vue from 'vue';

Vue.component('switch-button-component', {
    props: {
        isSwitchButtonVisible: {
            type: Boolean,
            default: false,
        },

        requestIndex: {
            type: Number,
        },

        labelClassMethod: {
            type: Function,
        },

        privateUrl: {
            type: String,
            default: '',
        },

        businessUrl: {
            type: String,
            default: '',
        },
    },

    methods: {
        handlePrivateLabelClass(requestType) {
            EventBus.$emit('request-type-changed', requestType);
            return requestType === 'private'
                ? 'new-form__label-switch--selected'
                : '';
        },

        handleBusinessLabelClass(requestType) {
            EventBus.$emit('request-type-changed', requestType);
            return requestType === 'business'
                ? 'new-form__label-switch--selected'
                : '';
        },
    },
});
